jQuery(document).ready(function onPardotButtonReady($) {
    'use strict';

    var pardotBases = {
        fi: 'https://go.cyklos.fi/l/991922/2023-10-13/41p3rx',
        no: 'https://go.cyklos.no/l/991922/2023-10-13/41p2qq',
        se: 'https://go.cyklos.se/l/991922/2023-10-11/41mc6t',
    };

    function getLang() {
        var match = window.location.pathname.match(/^\/([a-z]{2})\//);
        return match ? match[1] : 'se';
    }

    $('.js-pardot').on('click', function (e) {
        e.preventDefault();

        var product  = $(this).data('product');
        var lang     = getLang();
        var base     = pardotBases[lang] || pardotBases.se;
        var langParam    = lang || 'se';
        var thankYouBases = {
            fi: 'https://www.cyklos.se/fi/kitos-tarjouspyynto/',
            no: 'https://www.cyklos.se/no/takk-tilbud/',
        };
        var thankYou = (thankYouBases[lang] || 'https://www.cyklos.se/tack-offert/') + '?pname=' + encodeURIComponent(product) + '&lang=' + langParam;
        var url      = base +
            '?Product='                  + encodeURIComponent(product) +
            '&lang='                     + langParam +
            '&url_redirect_destination=' + encodeURIComponent(thankYou);

        window.open(url, '_blank', 'noopener,noreferrer');
    });
});
